export const STOP = 'pageflip/STOP'



// WEBPACK FOOTER //
// ./state/types/pageflip.js